module.exports = __webpack_public_path__ + "static/img/voice2_down.b0cb41ae.png";